(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["em-portfolio"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('em-portfolio-explorer')) {
 customElements.define('em-portfolio-explorer', class extends HTMLElement {
  connectedCallback() {
   this.controller?.abort(); this.controller = new AbortController(); const signal=this.controller.signal;
   this.tabs=[...this.querySelectorAll('[data-brand-tab]')];this.panels=[...this.querySelectorAll('[data-brand-panel]')];
   if (!this.tabs.length || this.tabs.length!==this.panels.length) return;
   this.querySelector('nav').setAttribute('role','tablist');
   this.tabs.forEach((tab,i)=>{tab.setAttribute('role','tab');tab.setAttribute('aria-controls',this.panels[i].id);this.panels[i].setAttribute('role','tabpanel');this.panels[i].setAttribute('aria-labelledby',tab.id);this.panels[i].tabIndex=0;
    tab.addEventListener('click',e=>{e.preventDefault();this.select(i);},{signal});
    tab.addEventListener('keydown',e=>{let n=i;if(e.key==='ArrowRight')n=(i+1)%this.tabs.length;else if(e.key==='ArrowLeft')n=(i-1+this.tabs.length)%this.tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=this.tabs.length-1;else if(e.key===' '){e.preventDefault();this.select(i);return;}else return;e.preventDefault();this.select(n);this.tabs[n].focus();},{signal});
   });
   this.dataset.enhanced='true';this.select(Math.max(0,this.panels.findIndex(p=>'#'+p.id===location.hash)));
   document.addEventListener('click',e=>{const link=e.target.closest('[data-em-select-brand]');if(link){const i=this.tabs.findIndex(t=>t.dataset.brand===link.dataset.emSelectBrand);if(i>=0)this.select(i);}
    const consult=e.target.closest('[data-em-interest]');if(consult&&this.contains(consult)){const select=document.querySelector('#em-beratung select[name="contact[Interesse]"]');if(select&&[...select.options].some(o=>o.value===consult.dataset.emInterest)){select.value=consult.dataset.emInterest;select.dispatchEvent(new Event('change',{bubbles:true}));}}
   },{signal});
   window.addEventListener('hashchange',()=>{const i=this.panels.findIndex(p=>'#'+p.id===location.hash);if(i>=0)this.select(i);},{signal});
   document.addEventListener('shopify:block:select',e=>{const i=this.panels.findIndex(p=>p.dataset.brandPanel===e.detail?.blockId);if(i>=0)this.select(i);},{signal});
  }
  select(i){this.tabs.forEach((t,n)=>{t.setAttribute('aria-selected',String(n===i));t.tabIndex=n===i?0:-1;this.panels[n].hidden=n!==i;});}
  disconnectedCallback(){this.controller?.abort();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["em-v4-device"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('em-xerf-feature')){customElements.define('em-xerf-feature',class extends HTMLElement{connectedCallback(){this.addEventListener('click',event=>{const link=event.target.closest('[data-xerf-consult]');if(!link||!this.contains(link))return;const label=link.querySelector('span');window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'xerf_cta_click',cta_position:'homepage_device_focus',cta_label:label?label.textContent.trim():'Einführung besprechen',destination_url:link.href})})}})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["em-v4-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('em-mobile-lead-cta')) {
  customElements.define('em-mobile-lead-cta', class extends HTMLElement {
    connectedCallback() {
      this.hero = document.querySelector('.em40-hero');
      this.target = document.querySelector('#em-beratung');
      this.ticking = false;
      this.update = () => {
        this.ticking = false;
        const mobile = window.matchMedia('(max-width: 749px)').matches;
        const heroPassed = this.hero && this.hero.getBoundingClientRect().bottom < 0;
        const beforeForm = !this.target || this.target.getBoundingClientRect().top > window.innerHeight * .58;
        this.classList.toggle('is-visible', Boolean(mobile && heroPassed && beforeForm));
      };
      this.requestUpdate = () => {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(this.update);
      };
      window.addEventListener('scroll', this.requestUpdate, { passive: true });
      window.addEventListener('resize', this.requestUpdate, { passive: true });
      this.querySelector('a')?.addEventListener('click', () => this.classList.remove('is-visible'));
      this.update();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.requestUpdate);
      window.removeEventListener('resize', this.requestUpdate);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["em-v4-lead"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('em-contact-form')){customElements.define('em-contact-form',class extends HTMLElement{connectedCallback(){const page=this.querySelector('[data-em-page]');if(page)page.value=window.location.href.split('#')[0];const params=new URLSearchParams(window.location.search);this.querySelectorAll('[data-em-utm]').forEach(input=>{input.value=params.get(input.dataset.emUtm)||''});const success=this.querySelector('[data-em-contact-success]');if(success){let canPush=true;const key='em4-contact-success:'+window.location.pathname+':'+success.dataset.formId;try{canPush=sessionStorage.getItem(key)!=='1';if(canPush)sessionStorage.setItem(key,'1')}catch(error){canPush=true}if(canPush){window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'ecomedic_contact_success',form_location:'homepage',lead_type:'consultation'})}success.focus()}}})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["em-v4-portfolio"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('em-portfolio-explorer')) {
 customElements.define('em-portfolio-explorer', class extends HTMLElement {
  connectedCallback() {
   this.controller?.abort(); this.controller = new AbortController(); const signal=this.controller.signal;
   this.tabs=[...this.querySelectorAll('[data-brand-tab]')];this.panels=[...this.querySelectorAll('[data-brand-panel]')];
   if (!this.tabs.length || this.tabs.length!==this.panels.length) return;
   this.querySelector('nav').setAttribute('role','tablist');
   this.tabs.forEach((tab,i)=>{tab.setAttribute('role','tab');tab.setAttribute('aria-controls',this.panels[i].id);this.panels[i].setAttribute('role','tabpanel');this.panels[i].setAttribute('aria-labelledby',tab.id);this.panels[i].tabIndex=0;
    tab.addEventListener('click',e=>{e.preventDefault();this.select(i);},{signal});
    tab.addEventListener('keydown',e=>{let n=i;if(e.key==='ArrowRight')n=(i+1)%this.tabs.length;else if(e.key==='ArrowLeft')n=(i-1+this.tabs.length)%this.tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=this.tabs.length-1;else if(e.key===' '){e.preventDefault();this.select(i);return;}else return;e.preventDefault();this.select(n);this.tabs[n].focus();},{signal});
   });
   this.dataset.enhanced='true';this.select(Math.max(0,this.panels.findIndex(p=>'#'+p.id===location.hash)));
   document.addEventListener('click',e=>{const link=e.target.closest('[data-em-select-brand]');if(link){const i=this.tabs.findIndex(t=>t.dataset.brand===link.dataset.emSelectBrand);if(i>=0)this.select(i);}
    const consult=e.target.closest('[data-em-interest]');if(consult&&this.contains(consult)){const select=document.querySelector('#em-beratung select[name="contact[Interesse]"]');if(select&&[...select.options].some(o=>o.value===consult.dataset.emInterest)){select.value=consult.dataset.emInterest;select.dispatchEvent(new Event('change',{bubbles:true}));}}
   },{signal});
   window.addEventListener('hashchange',()=>{const i=this.panels.findIndex(p=>'#'+p.id===location.hash);if(i>=0)this.select(i);},{signal});
   document.addEventListener('shopify:block:select',e=>{const i=this.panels.findIndex(p=>p.dataset.brandPanel===e.detail?.blockId);if(i>=0)this.select(i);},{signal});
  }
  select(i){this.tabs.forEach((t,n)=>{t.setAttribute('aria-selected',String(n===i));t.tabIndex=n===i?0:-1;this.panels[n].hidden=n!==i;});}
  disconnectedCallback(){this.controller?.abort();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["em-v4-roi"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('em-roi-calculator')) {
  customElements.define('em-roi-calculator', class extends HTMLElement {
    connectedCallback() {
      this.inputs = [...this.querySelectorAll('[data-roi-input]')];
      this.currency = new Intl.NumberFormat('de-AT', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
      this.controller = new AbortController();
      this.inputs.forEach(input => input.addEventListener('input', () => this.calculate(), { signal: this.controller.signal }));
      this.calculate();
    }
    calculate() {
      const value = name => Math.max(0, Number(this.querySelector(`[data-roi-input="${name}"]`)?.value || 0));
      const investment = value('investment');
      const margin = Math.max(0, value('price') - value('cost'));
      const annual = margin * value('sessions') * value('weeks');
      const monthly = annual / 12;
      const payback = monthly > 0 ? investment / monthly : 0;
      this.querySelector('[data-roi-output="monthly"]').textContent = this.currency.format(monthly);
      this.querySelector('[data-roi-output="annual"]').textContent = this.currency.format(annual);
      this.querySelector('[data-roi-output="payback"]').textContent = payback > 0 ? `${payback.toLocaleString('de-AT', { maximumFractionDigits: 1 })} Monate` : '–';
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class EcoMedicFooterLocalization extends HTMLElement {
    constructor() {
      super();

      this.input = this.querySelector('input[name="locale_code"], input[name="country_code"]');
      this.button = this.querySelector('button');
      this.panel = this.querySelector('ul');

      if (!this.input || !this.button || !this.panel) return;

      this.button.addEventListener('click', () => {
        const expanded = this.button.getAttribute('aria-expanded') === 'true';
        this.button.setAttribute('aria-expanded', (!expanded).toString());
        this.panel.toggleAttribute('hidden', expanded);
      });

      this.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.close();
      });

      this.querySelectorAll('a[data-value]').forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          this.input.value = event.currentTarget.dataset.value;
          const form = this.querySelector('form');
          if (form) form.submit();
        });
      });

      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.close();
      });
    }

    close() {
      if (!this.button || !this.panel) return;
      this.button.setAttribute('aria-expanded', 'false');
      this.panel.setAttribute('hidden', true);
    }
  }

  if (!customElements.get('localization-form')) {
    customElements.define('localization-form', EcoMedicFooterLocalization);
  }

  const ecoMedicFooterMedia = window.matchMedia('(min-width: 680px)');

  const syncEcoMedicFooterAccordions = (event) => {
    document.querySelectorAll('.emf__nav-item details').forEach((details) => {
      if (event.matches) {
        details.setAttribute('open', '');
      } else {
        details.removeAttribute('open');
      }
    });
  };

  syncEcoMedicFooterAccordions(ecoMedicFooterMedia);

  if (ecoMedicFooterMedia.addEventListener) {
    ecoMedicFooterMedia.addEventListener('change', syncEcoMedicFooterAccordions);
  } else {
    ecoMedicFooterMedia.addListener(syncEcoMedicFooterAccordions);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 100);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
